<div
  class="container-fluid image"
  *ngFor="let banner of banners; let index = index"
  [attr.id]="index"
  [preRender]="false"
  (deferLoad)="banner.show = true"
>
  <div class="container-section">
    <app-loader *ngIf="banner.loading"></app-loader>
    <ng-container *ngIf="banner.show">
      <img
        src="{{ banner.image }}"
        [hidden]="banner.loading"
        (load)="onload(index)"
        alt="..."
        style="width:100%;"
        class="banner"
      />
    </ng-container>

    <div class="centered">
      <a [routerLink]="'/products/' + banner.category_id">
        <h1>{{ banner.text }}</h1>
      </a>
    </div>
    <div class="text-center text-block" *ngIf="!banner.loading">
      <i
        style="color: red;"
        class="icon fa fa-angle-down fa-4x"
        (click)="triggerScrollTo(index)"
      ></i>
    </div>
  </div>
</div>
